import {
  ACC_SER_SERVICECODE_KEYVALUES_GET_FAILURE,
  ACC_SER_SERVICECODE_KEYVALUES_GET_REQUEST,
  ACC_SER_SERVICECODE_KEYVALUES_GET_SUCCESS,
  ACC_SER_SERVICECODE_KEYVALUES_UPDATE_FAILURE,
  ACC_SER_SERVICECODE_KEYVALUES_UPDATE_REQUEST,
  ACC_SER_SERVICECODE_KEYVALUES_UPDATE_SUCCESS,
} from '../actions/accountServices';

const initialState = {
  keyValuesArr: null,
  fetchingKeyValuesRequest: false,
  fetchingKeyValuesFailed: false,
  fetchingKeyValuesSuccess: false,
  updatingKeyValuesRequest: false,
  updatingKeyValuesFailed: false,
  updatingKeyValuesSuccess: false,
  updateKeyValuesStatus: false,
};

const accountServices = (state = initialState, action = null) => {
  // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
  switch (action.type) {
    case ACC_SER_SERVICECODE_KEYVALUES_GET_REQUEST:
      return Object.assign({}, state, {
        keyValuesArr: null,
        fetchingKeyValuesRequest: true,
        fetchingKeyValuesFailed: false,
        fetchingKeyValuesSuccess: false,
      });

    case ACC_SER_SERVICECODE_KEYVALUES_GET_SUCCESS:
      return Object.assign({}, state, {
        // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
        keyValuesArr: action.data.keyValues,
        fetchingKeyValuesRequest: false,
        fetchingKeyValuesFailed: false,
        fetchingKeyValuesSuccess: true,
      });

    case ACC_SER_SERVICECODE_KEYVALUES_GET_FAILURE:
      return Object.assign({}, state, {
        keyValuesArr: null,
        fetchingKeyValuesRequest: false,
        fetchingKeyValuesFailed: true,
        fetchingKeyValuesSuccess: false,
      });

    case ACC_SER_SERVICECODE_KEYVALUES_UPDATE_REQUEST:
      return Object.assign({}, state, {
        updatingKeyValuesRequest: true,
        updateKeyValuesStatus: false,
        updatingKeyValuesFailed: false,
        updatingKeyValuesSuccess: false,
      });

    case ACC_SER_SERVICECODE_KEYVALUES_UPDATE_SUCCESS:
      return Object.assign({}, state, {
        // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
        updateKeyValuesStatus: action.data.status === 'ok',
        updatingKeyValuesRequest: false,
        updatingKeyValuesFailed: false,
        updatingKeyValuesSuccess: true,
      });

    case ACC_SER_SERVICECODE_KEYVALUES_UPDATE_FAILURE:
      return Object.assign({}, state, {
        updateKeyValuesStatus: false,
        updatingKeyValuesRequest: false,
        updatingKeyValuesFailed: true,
        updatingKeyValuesSuccess: false,
      });

    default:
      return state;
  }
};

export default accountServices;
